export enum EmailStatus {
Initialized,
Queued,
Sent,
Failed,
}
